import { combineReducers } from 'redux'
import userInfoReducer from '../containers/appContainer/reducer'
import payoutReducer from '../containers/payout/reducer'
import utilityReducer from '../containers/utility/reducer'
import userManagementReducer from '../containers/userManagement/reducer'
import dealsReducer from '../containers/deals/reducer'
import etmTicketsReducer from '../containers/etmTickets/reducer'
import busServiceInfoReducer from '../containers/busServiceInfo/reducer'
import dashboardReducer from '../containers/dashboard/reducer'
import updateDriverDetailsReducer from '../containers/driverDetails/reducer'
import inventoryRefreshReducer from '../containers/inventoryRefresh/reducer'
import cancellationOffers from '../containers/cancellationOffers/reducer'
import citySearchAutoCompleteReducer from '../components/citySearchAutoComplete/reducer'
import ratingsReducer from '../containers/ratingsReviews/reducer'
import inventoryViewReducer from '../containers/inventoryView/reducer'
import restStopsReducer from '../containers/restStopConfiguration/reducer'


const combinedReducers = combineReducers({
  userInfoReducer,
  payoutReducer,
  utilityReducer,
  dealsReducer,
  userManagementReducer,
  etmTicketsReducer,
  dashboardReducer,
  updateDriverDetailsReducer,
  busServiceInfoReducer,
  inventoryRefreshReducer,
  cancellationOffers,
  citySearchAutoCompleteReducer,
  ratingsReducer,
  inventoryViewReducer,
  restStopsReducer,
})

export default combinedReducers
